import { Grid2, MenuItem, Select } from '@mui/material';
import { NumberField } from 'components/common/NumberField';
import { SettingsSection, SettingsSectionProps } from 'components/settings/SettingsSection';
import { useTranslation } from 'react-i18next';
import { SettingsField } from '../SettingsField';

export interface EventSettingsSectionProps extends SettingsSectionProps {}

export function EventSettingsSection(props: EventSettingsSectionProps) {
  const { t } = useTranslation();

  return (
    <SettingsSection
      title={t('eventSettings', 'Event')}
      description={t(
        'eventSettingsDescription',
        'Default settings for new events. Can be overridden per event.'
      )}
      {...props}
    >
      {/* <SettingsField
        label={t('maxSongRequests', 'Max song requests')}
        description={t(
          'maxSongRequestsDescription',
          'Maximum number of song requests allowed per event.'
        )}
      >
        <NumberField min={0} max={200} defaultValue={200} fullWidth />
      </SettingsField> */}
      {/* <SettingsField
        label={t('maxSongRequestsPerUser', 'Max song requests per user')}
        description={t(
          'maxSongRequestsPerUserDescription',
          'Maximum number of song requests each user can submit per event.'
        )}
      >
        <NumberField min={0} max={200} defaultValue={20} fullWidth />
      </SettingsField> */}
      <SettingsField
        label={t('requestCloseBeforeEvent', 'Request close before event')}
        description={t(
          'requestCloseBeforeEventDescription',
          'Time before the event when song requests close.'
        )}
      >
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 6 }}>
            <NumberField min={0} max={60} defaultValue={7} fullWidth />
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <Select fullWidth defaultValue="day">
              <MenuItem value="hour">hours</MenuItem>
              <MenuItem value="day">days</MenuItem>
              <MenuItem value="week">weeks</MenuItem>
            </Select>
          </Grid2>
        </Grid2>
      </SettingsField>
    </SettingsSection>
  );
}
